import { render, staticRenderFns } from "./SMSBrandNameList.vue?vue&type=template&id=4603ab2c"
import script from "./SMSBrandNameList.vue?vue&type=script&lang=js"
export * from "./SMSBrandNameList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports